import Router from './routes/router';

export default function App() {
  return <Router />;
}
